
import { forEach } from 'lodash';
import PGSHelper from '../../helpers/PGSHelper.js';
let pgsHelper = new PGSHelper();
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros=0;
  constructor() {

  }

  static getDocData(mainData) {

    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data)
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [ 20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: '25%',
              text: ''
            },
            {
              // fixed width
              width: '50%',
              alignment: 'center',
              bold: true,
              text: [
                'REPORTE CXC\n',
                'Del ' + mainData.FI + ' a ' + mainData.FF + '\n',
              ]
            },
            {
              // % width
              width: '25%',
              bold: true,
              text: [
                'Generado: ' + mainData.FG + '\n',
                'Hora: ' + mainData.HG + '\n',
              ]
            }
          ],
          // optional space between columns
          columnGap: 10
        },
        {
          columns: [
            {
              // fixed width
              width: '100%',
              table: {
                widths: ['*','*','*','*'],
                body: getTable
              }
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        { text: 'Fecha', border: [true, true, true, true], fontSize: 12 },
        { text: 'Descripcion', border: [true, true, true, true], fontSize: 12, alignment: 'center' },
        { text: 'Cantidad', border: [true, true, true, true], fontSize: 12 },
        { text: 'Monto', border: [true, true, true, true], fontSize: 12, alignment: 'right' },
      ],
    ]
    data.forEach((venta)=>{
      
      let rowToAdd = [];
      if(!venta.header & !venta.footer){
        rowToAdd = [
          { text: venta.fecha, border: [true, false, true, false], fontSize: 10 },
          { text: venta.Nombre, border: [true, false, true, false], fontSize: 10, alignment: 'center' },
          { text: venta.Cnt , border: [true, false, true, false], fontSize: 10 },
          { text: '$'+pgsHelper.formatNumber(venta.Cnt * venta.Pco.C), border: [true, false, true, false], fontSize: 10, alignment: 'right' },
        ]
        times.push(
            rowToAdd
          )
      }
     if(venta.header){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 12,colSpan: 4,fillColor:"#CCE3F4" },
        ]
        times.push(
            rowToAdd
          )
      }
      if(venta.footer){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 10,colSpan: 3,fillColor:"#DCDCDC"},
          { text: '', border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC" },
          { text: '', border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" },
          { text: '$'+pgsHelper.formatNumber(venta.total), bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right',fillColor:"#DCDCDC"},
          
        ]
        times.push(
            rowToAdd
          )
      }
      
    })



    let table = {
      border: [true, false, true, true],
      widths: ['*'],
      table: {
        body: times
      }
    }

    return times;
  }

  static getFirmas(data,porcentaje) {
    let times =  [
      [{ text: 'Mesero', border: [true, true, true, true], fontSize: 12 },
      { text: 'Total', border: [true, true, true, true], fontSize: 12,  },
      { text: '%'+porcentaje, border: [true, true, true, true], fontSize: 12, },
      { text: 'Firma', border: [true, true, true, true], fontSize: 12,  }]
    ]
    data.forEach((venta)=>{
      let rowToAdd = [];
      if(venta.tipo == 'footer'){
        rowToAdd = [
          { text: venta.Mesero, border: [true, true, true, true], fontSize: 10, },
          { text: '$'+pgsHelper.formatNumber(venta.Total), bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right'},
          { text: '$'+pgsHelper.formatNumber((venta.Total*Number(porcentaje))/100), bold: true,border: [true, true, true, true], fontSize: 10,alignment: 'right' },
         { text: " ", bold: true,border: [true, true, true, true], fontSize: 10,alignment: 'center' },
        ]
        times.push(
          rowToAdd
        )
      }
    })



    let table = {
      border: [true, false, true, true],
      widths: ['*'],
      heights: 60,
      table: {
        body: times
      }
    }

    return times;
  }



}